import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/partner/customerStat";

/**
 * 客户统计接口（客户概况 / 客户数据分布）
 *
 * 两个页面同属「客户统计」，共用这一个文件，不与客户列表的 customerApi 混用。
 */
export default {
    /** 查询客户概况：KPI + 类型/来源分布 + 增长趋势 + 行业/区域分布 + 价值排行 TOP10 */
    overview: (data) => axios.get({url: `${PREFIX_URI}/overview`, data}),
    /** 查询客户数据分布：总数 + 按客户类型的分布 */
    distribution: (data) => axios.get({url: `${PREFIX_URI}/distribution`, data}),
}
